import React from 'react';
import {ListDesignerConsumer} from '../../ContextComponents/ListDesignerContext/'

const ListDesignerHoc = (Wrapped) => {
    return (props) => {
        return (
            <ListDesignerConsumer>
                {
                    (screenProps) => {
                        return (
                            <Wrapped {...props} {...screenProps}/>
                        )
                    }
                }
            </ListDesignerConsumer>
        )
    }
};
export default ListDesignerHoc;